export default __webpack_public_path__ + "locales/el-GR/ConnectDialog.json?hash=94d7f0ab9d06ef5cacddebd65f4a879b";